import { TranslatedText } from "@/components/common/text";

export const MyOfferEmpty = ({ tab }) => {
    let title = tab !== "history" ? `No ${tab} offers` : "No history";
    let description = "";

    if (tab === "pending") {
        description = "Once you bid on a load from the Loadboard, it’ll show up here.";
    } else if (tab === "accepted") {
        description = "When a broker accepts your bid or booking, the load will show up here";
    } else if (tab === "declined") {
        description = "If a broker declines your bid, a declined load will show up here";
    } else if (tab === "countered") {
        description = "If a broker sends a counter bid, that load will show up here";
    } else {
        description = "All your offers will show up here";
    }

    return (
        <div className="flex flex-col w-full h-full items-center justify-center">
            <div className="text-cm-p-text-primary text-base/[25px] font-medium">
                <TranslatedText text={title} />
            </div>
            <div className="text-cm-p-text-secondary text-xs/[19px]">
                <TranslatedText text={description} />
            </div>
        </div>
    );
};
